// Q8 Breakpoints (valore base per mobile da 0 a 599)
export const Q8Breakpoints = {
  tablet: 600,          // da 600 a 839
  tabletLandscape: 840, // da 840 a 1199
  desktop: 1200,        // da 1200 a 1599
  desktopLarge: 1600    // da 1600 a X
};